import TransporterAnalyticsEvent from "./class.TransporterAnalyticsEvent";
import TransporterLog from "../class.TransporterLog.js";
import TransporterAnalyticsTrial from "./class.TransporterAnalyticsTrial";

const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterAnalyticsItem",
		color: "lime",
	},
});

const ALIAS = {
	GET_ID: "transporter_analytics_item_get_id",
	UPDATE: "transporter_analytics_item_update",
};

export default class TransporterAnalyticsItem extends TransporterAnalyticsEvent {
	/**
	 * @param {object} options
	 * @param {object} options.attributes
	 * @param {number} options.attributes.playthrough
	 * @param {string} options.attributes.pointer
	 * @param {number} options.attributes.context
	 * @param {string} options.attributes.type
	 * @param {boolean} options.attributes.user_interacted
	 * @param {number} options.attributes.started_at
	 * @param {number} options.attributes.completed_at
	 */
	constructor(options) {
		super(options);
		this.item_id = null;
		this.initialize();
	}

	initialize() {
		const error = _.bind(LOGGER.error, LOGGER);
		LOGGER.error = (...n) => {
			if (this.controller.isEnabled()) {
				this.controller.incrementErrorCount();
				error(...n);
			}
		};

		this.trials = [];

		if (!_.isNumber(this.item_id)) {
			this.idPromise = this.getId();
		}
	}

	async getId() {
		if (this.item_id) {
			return this.item_id;
		} else if (this.idPromise) {
			const id = await this.idPromise;
			return id;
		}
		const {pointer, context, type, user_interacted, started_at, completed_at} =
			this;
		try {
			const id = await this.controller.enqueue(ALIAS.GET_ID, {
				pointer,
				context: _.isNumber(context) ? context : null,
				type,
				user_interacted: user_interacted || false,
				started_at: started_at || Math.floor(Date.now() / 1000),
				completed_at: completed_at || null,
			});
			this.item_id = id;
			return id;
		} catch (e) {
			LOGGER.error(e);
			return null;
		}
	}

	async update(obj) {
		try {
			await this.controller.enqueue(ALIAS.UPDATE, {
				id: async () => {
					const id = await this.getId();
					return id;
				},
				...obj,
			});
			for (let key in obj) {
				this[key] = obj[key];
			}
		} catch (e) {
			LOGGER.error(e);
		}
	}

	createTrial(options) {
		try {
			const trial = new TransporterAnalyticsTrial({
				attributes: {
					controller: this.controller,
					...options,
					item: this,
				},
			});
			this.trials.push(trial);
			return trial;
		} catch (e) {
			LOGGER.error(e);
			return null;
		}
	}

	async setCompleted() {
		if (!this.completed_at) {
			try {
				await this.update({
					completed_at: Math.floor(Date.now() / 1000),
				});
			} catch (e) {
				LOGGER.error(e);
			}
		}
	}

	async setInteracted() {
		if (!this.user_interacted) {
			try {
				await this.update({
					user_interacted: true,
				});
			} catch (e) {
				LOGGER.error(e);
			}
		}
	}

	static get ALIAS() {
		return ALIAS;
	}
}
